import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MRulesItem } from './data-source';
import { EMRulesItemOption, mRulesItemOptions } from './typings';

@Component({
  selector: 'm-rules-item',
  template: `
    <nz-space nzAlign="center" class="m-rules-item">
      <nz-form-item *nzSpaceItem>
        <nz-form-control
          [nzValidateStatus]="item.nameValidator(item).status"
          [nzErrorTip]="item.nameValidator(item).text"
          [nzWarningTip]="item.nameValidator(item).text"
          [nzSuccessTip]="item.nameValidator(item).text"
          [nzValidatingTip]="item.nameValidator(item).text"
        >
          <nz-cascader [nzOptions]="item.nameOptions$ | async" [(ngModel)]="item.name" [nzLabelRender]="renderTpl"></nz-cascader>
        </nz-form-control>
      </nz-form-item>
      <ng-template #renderTpl let-labels="labels" let-selectedOptions="selectedOptions">
        <ng-container *ngFor="let label of labels; let isFirst = first; let isLast = last">
          <i *ngIf="isFirst" nz-icon nzType="unordered-list" nzTheme="outline" class="m-rules-item-icon"></i>
          <span *ngIf="!isLast">{{ label }} /</span>
          <span *ngIf="isLast">{{ label }}</span>
        </ng-container>
      </ng-template>
      <nz-form-item *nzSpaceItem>
        <nz-form-control>
          <nz-select class="m-rules-item-select" [(ngModel)]="item.option">
            <nz-option *ngFor="let option of options" [nzValue]="option.key" [nzLabel]="option.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <ng-container *ngIf="item.option !== optionKey.exist">
        <p class="m-rules-item-value" *nzSpaceItem>
          <nz-input-group nzCompact>
            <nz-form-item>
              <nz-form-control
                [nzValidateStatus]="item.valueValidator(item).status"
                [nzErrorTip]="item.valueValidator(item).text"
                [nzWarningTip]="item.valueValidator(item).text"
                [nzSuccessTip]="item.valueValidator(item).text"
                [nzValidatingTip]="item.valueValidator(item).text"
              >
                <nz-cascader
                  [class.m-rules-item-cascader-custom]="item.showCustomInput()"
                  [nzOptions]="item.valueOptions$ | async"
                  [(ngModel)]="item.value"
                ></nz-cascader>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item *ngIf="item.showCustomInput()">
              <nz-form-control
                [nzValidateStatus]="item.customValueValidator(item).status"
                [nzErrorTip]="item.customValueValidator(item).text"
                [nzWarningTip]="item.customValueValidator(item).text"
                [nzSuccessTip]="item.customValueValidator(item).text"
                [nzValidatingTip]="item.customValueValidator(item).text"
              >
                <input class="m-rules-item-custom-value-input" nz-input [(ngModel)]="item.customValue" />
              </nz-form-control>
            </nz-form-item>
          </nz-input-group>
        </p>
      </ng-container>
      <i *nzSpaceItem class="m-rules-item-close-icon" [hidden]="!item.deletable(item)" nz-icon (click)="onDelete()">
        <svg
          t="1630052597295"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1234"
          width="16"
          height="16"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <style type="text/css"></style>
          </defs>
          <path
            d="M813.696 165.056l45.248 45.248L557.184 512l301.76 301.696-45.248 45.248L512 557.184l-301.696 301.76-45.248-45.248L466.752 512 165.056 210.304l45.248-45.248L512 466.752z"
            p-id="1235"
          ></path>
        </svg>
      </i>
    </nz-space>
  `
})
export class MRulesItemComponent {
  @Input() item: MRulesItem = new MRulesItem({});
  @Output() readonly delete = new EventEmitter();

  options = mRulesItemOptions;
  optionKey = EMRulesItemOption;

  onDelete(): void {
    this.delete.emit();
  }
}
